// @flow
import FormsPageFormList from 'pages/FormsPage/FormsPageFormList'
import * as React from 'react'
import { Helmet } from 'react-helmet'
import type { QueueItem } from 'types/queue-item'
import Page from 'ui/organisms/Page'

import FormPageHeader from './FormPageHeader'

type Props = {
  handleItemClick?: (item: any) => void,
  hasUrlModal: boolean,
  isEmpty: boolean,
  isFetchingForms: boolean,
  isPacket?: boolean,
  items: Array<any>,
  itemsCount: number,
  itemsAsLinks?: boolean,
  loading: boolean,
  navigateToStartForms: () => void,
  onPublicFormClick: (string, string, string) => void,
  onPublicFormDismiss: () => void,
  onSelectResource: (string) => void,
  primaryAction: () => void,
  primaryActionDataCy: string,
  primaryActionText: string,
  publicFormName: ?string,
  publicUrl: ?string,
  selectedResources: Array<QueueItem>,
  setFormSearch?: (string) => void,
  formSearch?: string,
  tabletMode: boolean,
  title: string,
  setLoading: (boolean) => void,
}

function FormsPageContent({
  handleItemClick,
  hasUrlModal,
  isEmpty,
  isFetchingForms,
  isPacket = false,
  items,
  itemsCount,
  itemsAsLinks = false,
  loading,
  navigateToStartForms,
  onPublicFormClick,
  onPublicFormDismiss,
  onSelectResource,
  primaryAction,
  primaryActionDataCy,
  primaryActionText,
  publicFormName,
  publicUrl,
  selectedResources,
  setFormSearch,
  tabletMode,
  title,
  setLoading,
  formSearch,
}: Props): React.Node {
  return (
    <>
      <Helmet>
        <title>{title}/Zentake</title>
      </Helmet>
      <Page
        centerTitle={tabletMode}
        container={tabletMode}
        title={title}
        withBackButton={tabletMode}
      >
        <FormPageHeader
          formSearch={formSearch}
          primaryAction={primaryAction}
          primaryActionDataCy={primaryActionDataCy}
          primaryActionText={primaryActionText}
          setFormSearch={setFormSearch}
          tabletMode={tabletMode}
        />
        <FormsPageFormList
          handleItemClick={handleItemClick}
          hasUrlModal={hasUrlModal}
          isEmpty={isEmpty}
          isFetchingForms={isFetchingForms}
          isPacket={isPacket}
          items={items}
          itemsAsLinks={itemsAsLinks}
          itemsCount={itemsCount}
          loading={loading}
          navigateToStartForms={navigateToStartForms}
          onPublicFormClick={onPublicFormClick}
          onPublicFormDismiss={onPublicFormDismiss}
          onSelectResource={onSelectResource}
          publicFormName={publicFormName}
          publicUrl={publicUrl}
          selectedResources={selectedResources}
          setLoading={setLoading}
          tabletMode={tabletMode}
        />
      </Page>
    </>
  )
}

export default FormsPageContent
